import '../css/app.css';
import 'vuetify/dist/vuetify.min.css'
import Vuetify from 'vuetify'
import cs from 'vuetify/src/locale/cs'
import Vue from 'vue'

Vue.use(Vuetify)

const vuetify = new Vuetify({
  lang: {
    locales: { cs },
    current: document.documentElement.lang
  },
  icons: {
    iconfont: 'mdiSvg'
  },
  theme: { disable: true },
})

export default {
  el: '#app',
  vuetify,
  data () {
    return {
      menuOpened: false
    }
  },
  methods: {
    toggleMenu () {
      this.menuOpened ? this.menuOpened = false : this.menuOpened = true
    },
  }
}